import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/useMeterInput'
import PceSearchButton from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchButton'

const MeterInput = () => {
  const { meterIdOnBlurHandler, pceNo, isEditable, lastSentDate, canRequestMeterData, meterStatus, showPceSearchButton, t } = useMeterInput()

  return (
    <>
      <FormControl>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate || canRequestMeterData}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pceNo}
            label={pceNo ? t('subscriptionForm:pce_module.meter_id.label') : ''}
            placeholder={t('subscriptionForm:pce_module.meter_id.placeholder')}
            status={meterStatus}
          />
          <PceSearchButton hidden={!showPceSearchButton} />
        </>
      </FormControl>
    </>
  )
}

export default MeterInput
